import { render, staticRenderFns } from "./GeneralFiles.vue?vue&type=template&id=36b19333"
import script from "./GeneralFiles.vue?vue&type=script&lang=js"
export * from "./GeneralFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports